import React, {useEffect} from 'react'
import {KTIcon} from '../../../../_metronic/helpers'
import {useFormik} from 'formik'
import {IDLRList, IDLRManagementFormValues, initDLRMangementFormValues} from '../_model'
import ReactSelectBox from '../../../utils/components/ReactSelectBox'
import axios from 'axios'
import {BASE_URL} from '../../config'
import {useAuth} from '../../auth'
import {useRittApp} from '../../../utils/contextProvider/RittAppProvider'
import {useMutation, useQueryClient} from 'react-query'
import toast from 'react-hot-toast'

type Props = {
  selectedDlr: IDLRList | undefined
}

const CREATE_DLR_URL = `${BASE_URL}/api/protect/createDlrPush`
const UPDATE_DLR_URL = `${BASE_URL}/api/protect/updateDlrPushById`

const statusOptions = [
  {
    id: 0,
    value: 'Deactive',
    label: 'Deactive',
  },
  {
    id: 1,
    value: 'Active',
    label: 'Active',
  },
  {
    id: 2,
    value: 'Pause',
    label: 'Pause',
  },
]

const DLRManagementForm = ({selectedDlr}: Props) => {
  const queryClient = useQueryClient()
  const {userInfo} = useRittApp()

  const {mutate: configureDlr} = useMutation({
    mutationKey: ['dlrManagementList'],
    mutationFn: async (sendValues: Partial<IDLRManagementFormValues>) => {
      const response = await axios.post(CREATE_DLR_URL, sendValues)
      return response
    },
    onSuccess: (values) => {
      if (values.data.statuscode === 201) {
        toast.dismiss()
        toast.success(values.data.message)
        resetForm()
        queryClient.invalidateQueries({queryKey: ['dlrManagementList']})
      } else {
        toast.dismiss()
        toast.error(values.data.message)
      }
    },
  })

  const {mutate: updateDlr} = useMutation({
    mutationKey: ['dlrManagementList'],
    mutationFn: async (sendValues: Partial<IDLRList>) => {
      const response = await axios.put(UPDATE_DLR_URL, sendValues)
      return response
    },

    onSuccess: (values) => {
      if (values.data.statuscode === 201) {
        toast.dismiss()
        toast.success(values.data.message)
        resetForm()
        queryClient.invalidateQueries({queryKey: ['dlrManagementList']})
      } else {
        toast.dismiss()
        toast.error(values.data.message)
      }
    },
  })

  const formik = useFormik({
    initialValues: initDLRMangementFormValues,
    onSubmit: async (values) => {
      try {
        toast.loading('Processing..')
        console.log(values)
        const {userName, statusText, ...sendValues} = values

        if (selectedDlr) {
          const updatedValues = {
            id: selectedDlr.id,
            ...sendValues,
          }

          updateDlr(updatedValues)
        } else {
          configureDlr(sendValues)
        }
      } catch (error) {
        console.log(error)
      }
    },
  })

  const resetForm = () => formik.resetForm()

  const onSelectUser = (id: number) => formik.setFieldValue('userId', id)

  const onSelectStatus = (id: number) => formik.setFieldValue('status', id.toString())

  const getUsername = (id: number | null) => {
    const user = userInfo.find((usr) => usr.id === id)
    if (user) {
      console.log(user)
      return user.value
    } else {
      return ''
    }
  }

  useEffect(() => {
    resetForm()
    if (selectedDlr) {
      formik.setValues({
        userId: selectedDlr.userId,
        userName: getUsername(selectedDlr.userId),
        successUrl: selectedDlr.successUrl,
        faildUrl: selectedDlr.faildUrl,
        status: selectedDlr.status,
        statusText:
          selectedDlr.status === '1' ? 'Active' : selectedDlr.status === '2' ? 'Pause' : 'Deactive',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDlr])

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
      {/* begin::Modal dialog */}
      <div className='modal-dialog modal-dialog-centered modal-lg'>
        {/* begin::Modal content */}
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>DLR Managment Form</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>
          {/* begin::Modal body */}
          <div className='modal-body scroll-y my-5 mx-10'>
            <form onSubmit={formik.handleSubmit}>
              <div className='row row-cols-1'>
                <div className='col'>
                  <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>User</label>

                    <ReactSelectBox
                      formik={formik}
                      fieldValue='userName'
                      placeholder='Select user'
                      setSelect={onSelectUser}
                      options={userInfo}
                    />
                  </div>
                </div>

                <div className='col'>
                  <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Success URL</label>

                    <input
                      {...formik.getFieldProps('successUrl')}
                      placeholder='URL'
                      type='text'
                      className='form-control form-control custom-input mb-3 mb-lg-0'
                      autoComplete='off'
                    />
                  </div>
                </div>

                <div className='col'>
                  <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Failed URL</label>

                    <input
                      {...formik.getFieldProps('faildUrl')}
                      placeholder='URL'
                      type='text'
                      className='form-control form-control custom-input mb-3 mb-lg-0'
                      autoComplete='off'
                    />
                  </div>
                </div>

                <div className='col'>
                  <div className='fv-row mb-7'>
                    <label className='fw-semibold fs-6 mb-2'>Status</label>

                    <ReactSelectBox
                      formik={formik}
                      fieldValue='statusText'
                      placeholder='Select status'
                      options={statusOptions}
                      setSelect={onSelectStatus}
                    />
                  </div>
                </div>
              </div>
              <div className='text-center pt-15'>
                <button
                  type='reset'
                  className='btn btn-light me-3 border border-gray-600'
                  data-kt-users-modal-action='cancel'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                  onClick={resetForm}
                >
                  CLOSE
                </button>

                <button
                  type='submit'
                  className='btn btn-primary me-3'
                  data-kt-users-modal-action='cancel'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  SUBMIT
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DLRManagementForm
